import {
  SET_GAME_INFO,
  SET_DEVICE_TYPE,
  SET_NAV_ARTICLE_TYPE
} from './config'

const mutations = {
  [SET_GAME_INFO] (state, data) {
    state.gameInfo = data
  },
  [SET_DEVICE_TYPE] (state, type) {
    state.deviceType = type
  },
  [SET_NAV_ARTICLE_TYPE] (state, type) {
    state.navArticleType = type
  }
}

export default mutations
